const CLIENT_AUTH_KEY = "vs_client_auth";
const CLIENT_REGISTERED_KEY = "vs_client_registered";

export const saveClientSession = (user) => {
  const payload = {
    isAuthenticated: true,
    user: user || null,
    loggedAt: Date.now(),
  };
  localStorage.setItem(CLIENT_AUTH_KEY, JSON.stringify(payload));
};

export const clearClientSession = () => {
  localStorage.removeItem(CLIENT_AUTH_KEY);
};

export const markClientRegistered = (email = "") => {
  const payload = {
    isRegistered: true,
    email: String(email || "").trim().toLowerCase(),
    registeredAt: Date.now(),
  };
  localStorage.setItem(CLIENT_REGISTERED_KEY, JSON.stringify(payload));
};

export const isClientRegistered = () => {
  try {
    const raw = localStorage.getItem(CLIENT_REGISTERED_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return Boolean(parsed?.isRegistered);
  } catch (error) {
    console.error("Failed to parse registration state:", error);
    return false;
  }
};

export const getClientSession = () => {
  try {
    const raw = localStorage.getItem(CLIENT_AUTH_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    console.error("Failed to parse client session:", error);
    return null;
  }
};

export const isClientAuthenticated = () => {
  const session = getClientSession();
  if (!session?.isAuthenticated) return false;
  // Double check the authorization flag stored in the user object
  return Boolean(session?.user?.isAuthorized);
};
